<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="relative mb-8 text-gray-900">
    <a
      class="font-medium text-xl leading-tight text-gray-900 hover:text-red-600"
      :href="result.url"
      v-html="highlightedTitle"
    />
    <div
      class="text-base text-gray-600 mt-1 line-clamp-3"
      v-html="highlightedDescription"
    />
    <div
      v-if="metaText"
      class="font-bold uppercase text-xs text-gray-600 mt-2"
    >
      {{ metaText }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { ISearchResult } from './SearchPage.vue'

const props = defineProps<{
  result: ISearchResult
  query: string
}>()

const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const highlightedTitle = computed(() => {
  const title = props.result.title || ''
  if (!props.query) return title
  const regex = new RegExp(`(${escapeRegExp(decodeURI(props.query))})`, 'gi')
  return (
    title.replace(regex, '<b>$1</b>')
  )
})

const highlightedDescription = computed(() => {
  const description = props.result.Description || ''
  if (!props.query) return description
  const regex = new RegExp(`(${escapeRegExp(decodeURI(props.query))})`, 'gi')
  return (
    description.replace(regex, '<b>$1</b>') || 'No description available.'
  )
})

const publishedText = computed(() => {
  const val = props.result.sei_date_published
  if (!val) return ''
  const date = new Date(val)
  if (!isNaN(date.getTime())) {
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    })
  }
  return String(val)
})

const typeText = computed(() => props.result.AssetTypeName ? String(props.result.AssetTypeName) : '')

const metaText = computed(() => {
  if (publishedText.value && typeText.value) {
    return `${publishedText.value} \u00a0\u00a0\u2022\u00a0\u00a0 ${typeText.value}`
  } else if (publishedText.value) {
    return publishedText.value
  } else if (typeText.value) {
    return typeText.value
  }
  return ''
})
</script>